module.exports = __webpack_public_path__ + "static/media/grampians-motion-blur.a0e6fcd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/grampians-motion-blur.jpg
// module id = 132
// module chunks = 0